import { db, auth } from '@/firebase';

const user = {

    namespaced: true,

    state: () => ({
        info: null,
		marktimes: null,
		subordinates: null,
		vacations: null,
    }),


	getters: {
		isEmployee(state) {
			if (state.info) {
				// better handling role ID
				if (state.info.role === 'superadmin' || state.info.role == 'ryTk6gJU2Hdoff7CcX3e') return true
			}
			return false;
		},
		
		isTeamLeader(state) {
			if (state.info) {
				// better handling role ID
				if (state.info.role === 'superadmin' || state.info.role == 'rPHdxrt3Uatga4u9jx5T') return true
			}
			return false;
		},

		isAccounter(state) {
			if (state.info) {
				// better handling role ID
				if (state.info.role === 'superadmin' || state.info.role == 'u3WQdP6NiAhPrdQsBM4N') return true
			}
			return false;
		},

		isManager(state) {
			if (state.info) {
				// better handling role ID
				if (state.info.role === 'superadmin' || state.info.role == 'nZorCHA3D3opPKdu4Arx') return true
			}
			return false;
		},
	},


    mutations: {
        'SET_USER' (state, data) {
			state.info = data
		},
		'SET_MARKTIMES' (state, data) {
			state.marktimes = data
		},
		'SET_VACATIONS' (state, data) {
			state.vacations = data
		},
		'SET_SUBORDINATES' (state, data) {
			state.subordinates = data
		},
    },


    actions: {
        getUser({commit}) {
			return new Promise(resolve => {
				db
				.collection('users')
				.doc(auth.currentUser.uid)
				.onSnapshot(doc => {
					var user = doc.data()
					user.uid = doc.id;
					commit('SET_USER', user)
					return resolve();
				})
			})
		},

		getMarktimes({commit}) {

			return new Promise(resolve => {
				db
				.collection('marktimes')
				.where('user', '==', auth.currentUser.uid)
				.onSnapshot(query => {
					var marktimes = []
					query.forEach(doc => {
						var marktime = doc.data()
						marktime._key = doc.id;
						marktimes.push(marktime)
					})
					commit('SET_MARKTIMES', marktimes)
					return resolve();
				})

			})
		},

		getVacations({commit}) {

			return new Promise(resolve => {
				db
				.collection('vacations')
				.where('user', '==', auth.currentUser.uid)
				.onSnapshot(query => {
					var vacations = []
					query.forEach(doc => {
						var vacation = doc.data()
						vacation._key = doc.id;
						vacations.push(vacation)
					})
					commit('SET_VACATIONS', vacations)
					return resolve();
				})
			})
		},

		getSubordinates({commit, state}) {

			if (!state.info.subordinates) return [];
			if (state.info.subordinates.length === 0) return []

			db
			.collection('users')
			.where('uid', 'in', state.info.subordinates)
			.onSnapshot(query => {
				var subordinates = []
				query.forEach(doc => {
					var subordinate = doc.data()
					subordinates.push(subordinate)
				})
				commit('SET_SUBORDINATES', subordinates)
			})
		}
    }

}

export default user